<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <el-button type="primary" @click="add">新增</el-button>
      <BaseTable
        ref="baseTable"
        url="/admin/admin/index"
        :tableData.sync="tableData"
        :searchParams="searchData"
        :columns="columns"
      >
        <template #custom="{ scope }">
          {{ scope.row.title }}
        </template>
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>
          <el-button type="text" size="mini" @click="resetPassword(row)"
            >重置密码</el-button
          >
          <el-button type="text" size="mini" @click="change(row)">{{
            row.is_enabled == 1 ? "禁用" : "启用"
          }}</el-button>
          <el-button type="text" size="mini" @click="del(row)">删除</el-button>
        </template>
      </BaseTable>

      <el-drawer
        :title="drawerTitle"
        :visible.sync="isShowDrawer"
        direction="rtl"
      >
        <div style="padding: 40px">
          <el-form :model="formData" labelWidth="100px" size="medium">
            <el-form-item label="机构">
              <el-cascader
                v-model="formData.org_id"
                :options="orgOption"
                filterable
                change-on-select
                @change="handleOrgChange"
                :props="{
                  value: 'id',
                  label: 'orgName',
                  emitPath: false,
                }"
              ></el-cascader>
            </el-form-item>
            <!-- <el-form-item label="工号">
              <el-input v-model="formData.username"></el-input>
            </el-form-item> -->
            <el-form-item label="姓名">
              <el-input v-model="formData.realname" required></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="formData.phone" required></el-input>
            </el-form-item>
            <el-form-item label="用户类型">
              <el-select
                style="width: 100%"
                v-model="formData.user_type"
                placeholder="用户类型"
              >
                <el-option label="普通员工" value="普通员工"></el-option>
                <el-option label="业务员" value="业务员"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择岗位">
              <div>
                <el-select
                  style="width: 100%"
                  v-model="formData.group_id"
				  multiple
                  placeholder="选择岗位"
                >
                  <el-option
                    v-for="value in groupOption"
                    :key="value.id"
                    :label="value.title"
                    :value="value.id"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="备注">
              <el-input autosize v-model="formData.remark"></el-input>
            </el-form-item>
			<el-form-item label="天润工号">
			  <el-input v-model="formData.tr_number" required></el-input>
			</el-form-item>

<el-form-item label="线索池通道">
			  <el-select
			    style="width: 100%"
			    v-model="formData.tr_type"
			    placeholder="线索池通道"
			  >
          <el-option label="lgg1" value="lgg1"></el-option>
          <el-option label="lgg2" value="lgg2"></el-option>
          <el-option label="lgg3" value="lgg3"></el-option>
          <el-option label="lgg4" value="lgg4"></el-option>
          <el-option label="lgg6" value="lgg6"></el-option>
          <el-option label="lgg7" value="lgg7"></el-option>
          <el-option label="lgg8" value="lgg8"></el-option>
          <el-option label="lgg9" value="lgg9"></el-option>
          <el-option label="omg2" value="omg2"></el-option>
          <el-option label="omg5" value="omg5"></el-option>
          <el-option label="omg6" value="omg6"></el-option>
          <el-option label="omg7" value="omg7"></el-option>
          <el-option label="omg8" value="omg8"></el-option>
          <el-option label="cdbsb2" value="cdbsb2"></el-option>
          <el-option label="cdbsb4" value="cdbsb4"></el-option>
          <el-option label="cdbsb5" value="cdbsb5"></el-option>
          <el-option label="cdbsb7" value="cdbsb7"></el-option>
          <el-option label="cdbsb8" value="cdbsb8"></el-option>
          <el-option label="cdbsb9" value="cdbsb9"></el-option>
          <el-option label="yrc2" value="yrc2"></el-option>
          <el-option label="cdyr" value="cdyr"></el-option>
			  </el-select>
			</el-form-item>

            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "Jobno",
  comments: {},
  data() {
    return {
      drawerTitle: "",
      tableData: [],
      isShowDrawer: false,
      isShowPasswordDialog: true,
      formData: {},
      passwordFormData: {},
      searchData: {},
      isEdit: false,
      orgOption: [],
      groupOption: [],
    };
  },
  computed: {
    columns,
    searchFormOption,
  },
  created() {
    this.getOrgOption();
    this.getGroupOption();
  },
  methods: {
    getOrgOption() {
      this.$api.post("/admin/org/index", {}).then((res) => {
        this.orgOption = res.data.data;
      });
    },
    getGroupOption() {
      this.$api.post("/admin/groups/index", {}).then((res) => {
        this.groupOption = res.data.data;
      });
    },
    handleOrgChange(value) {
      if (value.length) {
        this.formData.org_id = value;
      }
    },

    add() {
      this.formData = {};
      this.isShowDrawer = true;
      this.drawerTitle = "新增工号";
    },

    edit(row) {
      this.formData = row;
      this.isEdit = true;
      this.isShowDrawer = true;
      this.drawerTitle = "编辑工号";
    },

    del(row) {
      this.$confirm("是否确认删除该工号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.$api
            .post(
              "/admin/admin/del",
              {
                id: row.id,
              },
              "删除"
            )
            .then(() => {
              this.$refs.baseTable.searchData();
              this.handleSearch();
            });
        })
        .catch(() => {
          this.$message({
            type: "formData",
            message: "已取消操作",
          });
        });
    },

    resetPassword(row) {
      this.$confirm(`确定重置【${row.realname}】的账号的密码吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.$api
            .post(
              "/admin/admin/resetPassword",
              {
                id: row.id,
              },
              "重置密码"
            )
            .then(() => {
              this.$refs.baseTable.searchData();
              this.handleSearch();
            });
        })
        .catch(() => {
          this.$message({
            type: "formData",
            message: "已取消操作",
          });
        });
    },

    change(row) {
      let is_enabled = row.is_enabled == 1 ? "禁用" : "启用";
      this.$confirm(`确定${is_enabled}【${row.realname}】的账号吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.$api
            .post(
              "/admin/admin/change",
              {
                val: row.id,
                field: "is_enabled",
                value: row.is_enabled == 1 ? 0 : 1,
              },
              is_enabled
            )
            .then(() => {
              this.$refs.baseTable.searchData();
              this.handleSearch();
            });
        })
        .catch(() => {
          this.$message({
            type: "formData",
            message: "已取消操作",
          });
        });
    },

    onSubmit() {
      this.$api.post("/admin/admin/save", this.formData, "更新").then(() => {
        this.isShowDrawer = false;
        this.$refs.baseTable.searchData();
      });
    },
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },
  },
};
</script>
